import { FC } from "react";
import FacebookLoginButton from 'react-facebook-login/dist/facebook-login-render-props'

import { useMultiStyleConfig, Button } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import Icon from "@components/Icon";
import { useMessage } from "@components/Message";
import { useRouter } from "@lib/router";

import { TFacebookLoginProps } from "../types";
import getFbAppId from "../utils/getFbAppId";

const FacebookLogin: FC<TFacebookLoginProps> = ({ onSubmit, googleEnabled }) => {
  const { t } = useTranslation();
  const styles = useMultiStyleConfig("Login", {});
  const setMessage = useMessage();

  const { defaultLocale } = useRouter();

  const fbAppId = getFbAppId(defaultLocale);

  if (!fbAppId) {
    return null;
  }

  const handleFailure = () => {
    setMessage({
      message: t("login-general_error"),
      props: {
        variant: "error",
        icon: <Icon icon="warning" size="1.45rem" />,
        canClose: true,
        padding: "0.45rem 0.75rem",
      },
      zone: "login",
    });
  };

  const handleResponse = ({ accessToken }) => {
    if (!accessToken) {
      handleFailure();
      return;
    }
    onSubmit({ accessToken });
  };

  return (
      <FacebookLoginButton
        appId={fbAppId}
        fields="name,email"
        callback={handleResponse}
        onFailure={handleFailure}
        disableMobileRedirect
        render={(renderProps: any) => (
          <button
            style={googleEnabled ? (styles.facebookLogin as React.CSSProperties) : (styles.facebookLoginShorter as React.CSSProperties)}
            onClick={renderProps.onClick}
            className="fb-login-button medium"
            type="button"
          >
            <Icon icon="facebook" size="24px" />
          </button>
        )}
      />
  )
};
export default FacebookLogin;
